import axios from 'axios';
import { useToast } from 'vue-toastification';
const toast = useToast();

const apiClient = axios.create({
  //baseURL: 'http://localhost:11443',
  baseURL: import.meta.env.VITE_SERVER_BASE_URl,
  timeout: 30000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

apiClient.interceptors.request.use(
  function (request) {
    // Do something before request is sent
    request.data && console.log(request.data);
    return request;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(new Error(error.message));
  }
);

// Add a response interceptor
apiClient.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.table(response.data);
    response.data?.message && toast.success(response.data.message);
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // error.message && toast.error(error.message);
    return Promise.reject(new Error(error.message));
  }
);

export { apiClient };
